export default {
    errors: {
        cannotBeBlank: "This field cannot be blank",
        required: "This field is required",
        somethingWentWrong: "Something went wrong!!!",
      },
      logs: {
        time: "Time",
        username: "User Name",
        role: "Role",
        terminalID: "Terminal ID",
        moduleAccessed: "Module Accessed",
        typeOfAccess: "Type of Access",
        activityLogDetails: "Activity Log Details",
        userId: "User ID",
        lastLogin: "Last Login",
        geoAccPoint: "Geographical access point",
        ipAdd: "IP address",
        filesAccessed: "Files accessed",
        funAccessed: "Function accessed",
        webUrl: "Web page URL",
        unsuccAtmp: "Unsuccessful Login attempt",
        view: "View",
        membershipType: "Membership Type",
      },

      validation: {
        exporterRequired: "Exporter field is required",
        importerRequired: "Importer field is required",
        portOfOriginRequired: "Port of Origin field is required",
        containerSizeNumber: "Container size field must be a number",
        containerCapacityNumber: "Container capacity field must be a number",
      },
}